import React, { useState } from 'react';
import ProfileTabContext from './ProfileTabContext';
const ProfileTabProvider = ({ children }) => {
	const [activeProfileTab, setActiveProfileTab] = useState('profilesettings');
	//console.log(activeProfileTab, 'activeProfileTab');

	return (
		<ProfileTabContext.Provider
			value={{ activeProfileTab, setActiveProfileTab }}>
			{children}
		</ProfileTabContext.Provider>
	);
};

export default ProfileTabProvider;
